import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getDayModels = () => {
    return request({
        url: namespace + "/daymodels",
        method: "get",
    });
};

export const getDayModel = (dm_id) => {
    return request({
        url: namespace + "/daymodel/" + dm_id,
        method: "get",
    });
};

export const createDayModel = (payload) => {
    return request({
        url: namespace + "/daymodel",
        data: payload,
        method: "post",
    });
};

export const updateDayModel = (dm_id, payload) => {
    return request({
        url: namespace + "/daymodel/" + dm_id,
        data: payload,
        method: "put",
    });
};

export const destroyDayModel = (dm_id) => {
    return request({
        url: namespace + "/daymodel/" + dm_id,
        method: "delete",
    });
};